import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { Button } from "@mui/material";

export const LoginButton = ({ email, style="contained", theme="default", text="Log In" }: { email?: string, style?: "contained" | "text", theme?: "default" | "advisor", text?: string }) => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/login/silent",
      },
      authorizationParams: {
        prompt: "login",
        login_hint: email,
        "ext-theme": theme,
      },
    });
  };

  return (
    <Button 
      id="qsLoginBtn"
      color="primary"
      variant={style === "contained" ? "contained" : "text"}
      className="btn-margin"
      onClick={handleLogin}>
      {text}
    </Button>
  );
};
